export const SITE_NAME = '노후든든';
export const SITE_URL = 'https://www.enzo2.life';
export const CONTACT_EMAIL = 'contact@enzo2.life';
export const OG_IMAGE_URL = `${SITE_URL}/og-image.png`;

export function buildAbsoluteUrl(path: string = '/'): string {
  return new URL(path, SITE_URL).toString();
}
